import { orderBy } from 'lodash';
import { ProjectAdminMenuType } from './types';
export const ProjectAdminMenuItems = () => {
  const menuItems = [
    {
      label: `General`,
      value: 'general',
      type: ProjectAdminMenuType.GENERAL,
      sequenceOrder: 1,
    },
    {
      label: `User Admin`,
      value: 'user-admin',
      type: ProjectAdminMenuType.USER_ADMIN,
      sequenceOrder: 2,
    },

    {
      label: `Features`,
      value: 'Features',
      type: ProjectAdminMenuType.FEATURES,
      sequenceOrder: 3,
    },
    {
      label: `Project Admin`,
      value: 'project-admin',
      type: ProjectAdminMenuType.PROJECT_ADMIN,
      sequenceOrder: 4,
    },
    {
      label: `Toolrooms`,
      value: 'toolrooms',
      type: ProjectAdminMenuType.TOOLROOMS,
      sequenceOrder: 5,
    },
    // {
    //   label: `Notifications`,
    //   value: 'notifications',
    //   type: ProjectAdminMenuType.NOTIFICATIONS,
    //   sequenceOrder: 5,
    // },
    // {
    //   label: `Units & Values`,
    //   value: 'units-values',
    //   type: ProjectAdminMenuType.UNITS_VALUES,
    //   sequenceOrder: 5,
    // },
    {
      label: `Sync`,
      value: 'Sync',
      type: ProjectAdminMenuType.SYNC,
      sequenceOrder: 6,
    },
    {
      label: `Tool-Catalogs`,
      value: 'Tool-Catalogs',
      type: ProjectAdminMenuType.TOOL_CATALOG,
      sequenceOrder: 7,
    },
  ];

  const orderedMenItems = orderBy(menuItems, 'sequenceOrder');
  return orderedMenItems;
};
